import { ErrorMessage, Field, FieldInputProps, FormikProps } from 'formik';

type Props = {
  label: string;
  name: string;
  placeholder?: string;
  maxLength?: number;
  onkeydown?: any;
};

const InputTextArea = (props: Props) => {
  const { label, name, placeholder, maxLength, onkeydown } = props;

  return (
    <Field type="text" name={name} label={label}>
      {({
        field,
        form,
      }: {
        field: FieldInputProps<any>;
        form: FormikProps<any>;
      }) => (
        <div>
          <textarea
            onChange={field.onChange}
            onBlur={field.onBlur}
            onKeyDown={onkeydown}
            value={field.value}
            name={name}
            className={`rounded-md border h-[175px] ${
              form.errors[name]
                ? 'border-pink_drink'
                : 'border-gray-400  text-black'
            } px-4 py-2 text-sm w-full focus:outline-none`}
            placeholder={placeholder}
            maxLength={maxLength}
            aria-label={label}
          />
          {maxLength && field.value?.length >= maxLength ? (
            <p className="text-pink_drink text-xs mt-1 text-left">
              Please limit your message to {maxLength} characters
            </p>
          ) : null}
          <ErrorMessage
            name={name}
            component="p"
            className="text-red-500 text-xs mt-1 text-left"
          />
        </div>
      )}
    </Field>
  );
};

export default InputTextArea;
